const {
  filtersHidden,
  filtersOrder,
  filtersWithAlphabeticallySortedOptions,
  filtersInitiallyOpen,
} = require('./filters');
const formatItemcount = require('../libs/twig/format_itemcount');

if (!Array.prototype.findIndex) {
  // eslint-disable-next-line no-extend-native
  Object.defineProperty(Array.prototype, 'findIndex', {
    value(predicate) {
      if (this == null) {
        throw new TypeError('Array.prototype.findIndex called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      const list = Object(this);
      // eslint-disable-next-line no-bitwise
      const length = list.length >>> 0;
      // eslint-disable-next-line prefer-rest-params
      const thisArg = arguments[1];
      let value;

      for (let i = 0; i < length; i += 1) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return i;
        }
      }
      return -1;
    },
    enumerable: false,
    configurable: false,
    writable: false,
  });
}

const addCountToDisplayName = (displayName, count) => {
  switch (typeof displayName) {
    default:
      return `${displayName} (${formatItemcount(count)})`;

    case 'object':
      return Object.keys(displayName).reduce((acc, language) => {
        acc[language] = `${displayName[language]} (${formatItemcount(count)})`;

        return acc;
      }, {});
  }
};

module.exports = (filters, hardwiredFilters = {}) => {
  const adjustedFilters = filters.filter((filter) => filtersHidden.indexOf(filter.name) === -1)
    .map((filter) => {
      switch (true) {
        default:
        case filter.type === 'fulltext':
          return {
            component: 'input',
            data: {
              type: 'search',
              name: `filter[${filter.name}]`,
              label: `ui.filter.${filter.name}.label`,
              placeholder: `ui.filter.${filter.name}.placeholder`,
              value: filter.values.length ? filter.values[0] : undefined,
              autocomplete: 'off',
            },
          };

        case filter.type === 'range':
        case filter.type === 'range_int':
          return {
            component: 'range',
            data: {
              name: `filter[${filter.name}]`,
              label: `ui.filter.${filter.name}.label`,
              placeholder: `ui.filter.${filter.name}.placeholder`,
              value: filter.values,
              min: filter.range.min,
              max: filter.range.max,
            },
          };

        case filter.type === 'toggle':
          return {
            component: 'input',
            data: {
              type: 'toggle',
              name: `filter[${filter.name}]`,
              label: `ui.filter.${filter.name}.label`,
              value: filter.values.length ? filter.values[0] : undefined,
            },
          };

        case filter.type === 'set_one':
          return {
            component: (filter.options.length < 3 || filter.name === 'availability') ? 'radio-group' : 'select',
            data: {
              name: `filter[${filter.name}]`,
              label: `ui.filter.${filter.name}.label`,
              placeholder: filter.options.length ? `ui.filter.${filter.name}.placeholder` : 'ui.filter.disabled.placeholder',
              options: filter.options.map((option) => ({
                label: option.count > 0 ? addCountToDisplayName(option.displayName, option.count) : option.displayName,
                value: `${option.value}`,
                count: option.count,
              })),
              value: filter.values.length ? `${filter.values[0]}` : undefined,
              disabled: !filter.options.length,
            },
          };

        case filter.type === 'set_any' || filter.type === 'set_all':
          return {
            component: 'select',
            data: {
              name: `filter[${filter.name}]`,
              label: `ui.filter.${filter.name}.label`,
              placeholder: filter.options.length ? `ui.filter.${filter.name}.placeholder` : 'ui.filter.disabled.placeholder',
              options: filter.options
                .filter((option) => !hardwiredFilters
                  || !hardwiredFilters[filter.name]
                  || `${option.value}` !== `${hardwiredFilters[filter.name]}`)
                .map((option) => ({
                  label: option.count > 0 ? addCountToDisplayName(option.displayName, option.count) : option.displayName,
                  value: `${option.value}`,
                  count: option.count,
                })),
              value: filter.values,
              sort: filtersWithAlphabeticallySortedOptions.indexOf(filter.name) > -1,
              disabled: !filter.options.length,
              multiple: true,
            },
          };
      }
    })
    .map((filter) => {
      if (filtersInitiallyOpen.findIndex((entry) => filter.data.name && filter.data.name.indexOf(`[${entry}]`) > -1) > -1) {
        filter.data.expanded = true;
      }
      return filter;
    });

  adjustedFilters.sort((a, b) => {
    const indexA = filtersOrder.findIndex((entry) => a.data.name && a.data.name.indexOf(`[${entry}]`) > -1);
    const indexB = filtersOrder.findIndex((entry) => b.data.name && b.data.name.indexOf(`[${entry}]`) > -1);

    if (indexA < indexB) {
      return -1;
    }

    if (indexA > indexB) {
      return 1;
    }

    return 0;
  });

  return adjustedFilters;
};



// WEBPACK FOOTER //
// ./src/_utilities/filtercomponents.js